var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: _vm.id } },
    [
      _vm.datetime_list.length !== 0
        ? _c("v-select", {
            staticClass: "date_time__select__box",
            attrs: {
              items: _vm.datetime_list,
              id: "atlas_table_datetime_select",
              "item-text": "text",
              "item-value": "value",
              label: "選擇時間區間",
              "hide-details": ""
            },
            model: {
              value: _vm.current_datetime,
              callback: function($$v) {
                _vm.current_datetime = $$v
              },
              expression: "current_datetime"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "table" }, [
        _c(
          "table",
          { staticClass: "table__container" },
          [
            _vm._l(_vm.img_list, function(row_date) {
              return [
                _c(
                  "tr",
                  _vm._l(row_date, function(column, column_index) {
                    return _c(
                      "td",
                      {
                        key: column_index,
                        staticClass: "table__header table__header__border"
                      },
                      [
                        _c("div", {}, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(column.text) +
                              "\n                        "
                          )
                        ])
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "tr",
                  _vm._l(row_date, function(column, column_index) {
                    return _c("td", { key: column_index }, [
                      _c(
                        "div",
                        {},
                        [
                          _c("v-img", {
                            attrs: {
                              src: _vm.get_src(column.img),
                              "aspect-ratio": "1",
                              id: "img_id_for_selector",
                              contain: ""
                            },
                            on: {
                              click: function($event) {
                                return _vm.show_detailed_picture(column.img)
                              },
                              error: function($event) {
                                return _vm.change_src(
                                  row_date[column_index].img
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  }),
                  0
                )
              ]
            })
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }